import React from 'react'
import {
    Box,
    Button,
    Checkbox,
    Container,
    Dialog,
    DialogActions,
    DialogTitle,
    Grid,
    IconButton,
    Stack,
    TextField,
    Typography,
    DialogContent,
    Avatar,
    Input,
    OutlinedInput,
    Chip,
    Divider,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from 'react';
import ind_number_plat from "../../../assets/images/ind-number-plat.png";
import toast from "react-hot-toast";
import rcverify from "../../../assets/images/rcverify.png";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useRef } from 'react';
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate, Link } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';

const NumberPlateDialog = ({
    isNumberPlateDialogOpen,
    setNumberPlateDialogOpen,
    handleNumberPlateButtonClick,
    handleCloseNumberPlateDialog,
    numberPlateSearch,
    numberPlateData,
    setNumberPlateData,
    handleSearch2,
    navigateToOEMCatalog,
    handleSearchAndOpenDialog,
    handleAdd,
    resetNumberPlateSearch,
    setNumberPlateSearch,
    numplateSearch,
    isloading,
    handleKeyPress,
}) => {
    const loggedIn = localStorage.getItem("is_login");
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [cars, setCars] = useState({
        model: "",
        generation: "",
    });
    const [selectedConfigIndex, setSelectedConfigIndex] = useState(0);
    const [selectedCar, setSelectedCar] = useState(null);
    const [isMapped, setismapped] = useState(false);
    const path = window.location.pathname.split("/")[1];

    useEffect(() => {
        if (numberPlateData && numberPlateData.length > 0) {
            setSelectedConfigIndex(0); // Set the first configuration as default
            setSelectedCar(numberPlateData[0]);
            const firstCar = numberPlateData[0];
            setCars({
                model: firstCar.model.split(' ')[0],
                generation: firstCar.model.split(' ').slice(1).join(' '),
            });
            if (firstCar.is_mapped === 1) {
                setismapped(true);
            }
        } else {
            setCars({
                model: "",
                generation: "",
            });
        }
    }, [numberPlateData]);

    const handleConfigSelection = (index) => {
        setSelectedConfigIndex(index);
        const selectedCar1 = numberPlateData[index];
        setCars({
            model: selectedCar1.model.split(' ')[0],
            generation: selectedCar1.model.split(' ').slice(1).join(' '),
        });
        setSelectedCar(selectedCar1);
        if (selectedCar1.is_mapped === 1) {
            setismapped(true);
        }
    };


    return (
        <>
            <Dialog
                open={isNumberPlateDialogOpen}
                onClose={handleCloseNumberPlateDialog}
                maxWidth="sm"
                fullWidth
                sx={{
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
            >
                <DialogTitle
                    sx={{
                        padding: "8px 16px 5px 16px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            // fontSize: "30px",
                        }}
                    >
                        <Typography variant="h5" color={"#ff6333"} sx={{ textAlign: "center", fontWeight: "700" }}>Search By Number Plate</Typography>
                        <IconButton onClick={handleCloseNumberPlateDialog}>
                            <CloseIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        "&.MuiDialogContent-root": {
                            padding: "0px 10px 5px 10px",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                        }}
                    >
                        <Input
                            fullWidth
                            disableUnderline
                            placeholder="MH01XY0001"
                            onKeyDown={handleKeyPress}
                            startAdornment={(
                                <InputAdornment position="start">
                                    <img
                                        src={ind_number_plat}
                                        alt="Your Image"
                                        style={{
                                            width: '15px',
                                            marginRight: '-13px',
                                            marginLeft: '5px',
                                            marginTop: { lg: '10px', xs: "0px", md: "10px" }
                                        }}
                                    />
                                </InputAdornment>
                            )}
                            sx={{
                                borderRadius: "7px",
                                paddingRight: "20px",
                                height: "45px",
                                width: { lg: "250px", xs: "200px", md: "250px" },
                                border: "2px solid #003399",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                backgroundColor: "#e8e8e8",
                                '& input': {
                                    padding: '10px',
                                    fontSize: { lg: '30px', md: "30px", xs: '25px' },
                                    '::placeholder': {
                                        fontSize: { lg: '30px', md: "30px", xs: "25px" },
                                    },
                                },
                            }}
                            value={numberPlateSearch}
                            onChange={(e) => setNumberPlateSearch(e.target.value.toUpperCase())}
                        />
                        <Box
                            sx={{
                                backgroundColor: "#003399",
                                cursor: "pointer",
                                marginLeft: "10px",
                                border: "none",
                                height: "45px",
                                width: "45px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "7px",
                            }}
                            onClick={numplateSearch}
                        >
                            <SearchIcon sx={{ color: "#fff", fontSize: "1.5rem" }} />
                        </Box>
                    </Box>

                    <Grid item container direction="column" alignItems="center" sx={{ marginTop: '7px', marginBottom: '7px' }}>
                        <Link
                            onClick={(e) => {
                                resetNumberPlateSearch();
                                e.preventDefault();
                            }}
                            className="linkStyle"
                        >
                            Reset Number Plate
                        </Link>

                    </Grid>

                    <Box>
                        {isloading ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: "300px",
                                }}
                            >
                                <CircularProgress color="inherit" />
                            </Box>
                        ) : (
                            <>
                                {numberPlateData && numberPlateData.length > 0 && (
                                    <Grid container alignItems="center" justifyContent="center" sx={{ marginBottom: '8px' }}>
                                        <Box sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            width: { lg: "60%", xs: "100%" },
                                            borderRadius: "60px 60px 5px 5px",
                                            backgroundColor: "#FF6633",
                                            padding: "5px",
                                        }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flex: 1 }}>
                                                <Typography sx={{ color: "white", textAlign: "center", fontWeight: 500 }}>
                                                    Details of the Detected Car
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )}

                                {numberPlateData && numberPlateData.length > 0 ? (
                                    <Grid container alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ width: '100%' }}>
                                            {numberPlateData && numberPlateData.length > 0 && (
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", width: '100%' }}>
                                                    <Stack spacing={2} direction="column" alignItems="center" justifyContent="center" sx={{ flexWrap: "wrap", width: '100%' }}>
                                                        {numberPlateData[0].icon ? (
                                                            <Box
                                                                sx={{
                                                                    width: "75px",
                                                                    height: "75px",
                                                                    boxShadow: "0 5px 8px rgba(0, 0, 0, 0.5)",
                                                                    borderRadius: "5px",
                                                                    overflow: "hidden",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                <img
                                                                    src={numberPlateData[0].brand_icon}
                                                                    alt="Car Image"
                                                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                                />
                                                            </Box>
                                                        ) : (
                                                            <img src={rcverify} style={{ width: "75px", height: "75px" }} />
                                                        )}
                                                        <Stack spacing={1} direction="column" alignItems="center" justifyContent="flex-start" sx={{ flexWrap: "wrap" }}>
                                                            <Stack spacing={1} direction="row" alignItems="center" justifyContent="center" sx={{ flexWrap: "wrap", }}>
                                                                <Chip
                                                                    label={numberPlateData[0].car_maker}
                                                                    variant="outlined"
                                                                    style={{
                                                                        backgroundColor: '#f5f5f5',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        fontSize: "1.1rem",
                                                                        borderRadius: "10px",
                                                                        fontWeight: "bold",
                                                                    }}
                                                                />
                                                                <Chip
                                                                    label={numberPlateData[0].model}
                                                                    variant="outlined"
                                                                    style={{
                                                                        backgroundColor: '#f5f5f5',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        fontSize: "1.1rem",
                                                                        borderRadius: "10px",
                                                                        fontWeight: "bold",
                                                                    }}
                                                                />
                                                            </Stack>

                                                        </Stack>
                                                    </Stack>
                                                </Box>
                                            )}
                                        </Grid>

                                        <Divider sx={{ width: "100%", borderColor: "#CBD4E7", mt: "8px", mb: "8px" }} />

                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ width: '100%' }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flex: 1,
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    height: "160px",
                                                    overflowY: "auto",
                                                    padding: "0 10px",
                                                    // width: '100%',
                                                }}
                                            >
                                                {numberPlateData && numberPlateData.length > 0 && (
                                                    <Grid container spacing={2}>
                                                        {numberPlateData.map((data, index) => (
                                                            <Grid item lg={6} md={6} sm={6} xs={12} key={index}>
                                                                <Box
                                                                    sx={{
                                                                        margin: "5px 0",
                                                                        boxShadow: "0 5px 8px rgba(0, 0, 0, 0.5)",
                                                                        borderRadius: "5px",
                                                                        display: "flex",
                                                                        flex: 1,
                                                                        border: `2px solid ${selectedCar?.modification_id === data?.modification_id
                                                                            ? "#FF6633"
                                                                            : "transparent"
                                                                            }`,
                                                                        backgroundColor: "#f5f5f5",
                                                                        alignItems: "center",
                                                                        justifyContent: "flex-start",
                                                                        padding: "10px",
                                                                    }}
                                                                    onClick={() => handleConfigSelection(index)}
                                                                >
                                                                    <Grid container spacing={2}>
                                                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                                                            {data.icon ? (
                                                                                <Box
                                                                                    sx={{
                                                                                        width: "70px",
                                                                                        height: "70px",
                                                                                        borderRadius: "5px",
                                                                                        boxShadow: "0 5px 8px rgba(0, 0, 0, 0.5)",
                                                                                        backgroundColor: "#fff",
                                                                                        overflow: "hidden",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src={data.icon}
                                                                                        alt="Car Image"
                                                                                        style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                                                    />
                                                                                </Box>
                                                                            ) : (
                                                                                <img src={rcverify} style={{ width: "70px", height: "70px" }} alt="Default Car" />
                                                                            )}
                                                                        </Grid>

                                                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                                                            <Grid container spacing={1}>
                                                                                <Grid item xs={12}>
                                                                                    <Grid container>
                                                                                        <Grid item xs={6}>
                                                                                            <Typography
                                                                                                variant="body2"
                                                                                                sx={{
                                                                                                    fontSize: "14px",
                                                                                                    fontWeight: "500",
                                                                                                    color: "#000",
                                                                                                }}
                                                                                            >
                                                                                                {data.date}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                        <Grid item xs={6}>
                                                                                            <Typography
                                                                                                variant="body2"
                                                                                                sx={{
                                                                                                    fontSize: "14px",
                                                                                                    fontWeight: "500",
                                                                                                    color: "#000",
                                                                                                }}
                                                                                            >
                                                                                                {data.engine_type}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>

                                                                                <Grid item xs={12}>
                                                                                    <Typography
                                                                                        variant="body1"
                                                                                        sx={{
                                                                                            fontSize: "14px",
                                                                                            fontWeight: "500",
                                                                                            color: "#000",
                                                                                        }}
                                                                                    >
                                                                                        {data.configration_name}
                                                                                    </Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                )}
                                            </Box>
                                        </Grid>

                                        <Grid
                                            container
                                            fullWidth
                                            sx={{ alignItems: 'center', justifyContent: 'space-between', mt: 1 }}
                                        >
                                            {isMapped && path !== "products-list" ? (
                                                <>
                                                    <Grid item xs={5.8} sm={5.8} md={5.8} lg={5.8}>
                                                        <Button
                                                            variant="contained"
                                                            fullWidth
                                                            sx={{
                                                                backgroundColor: "rgba(255, 102, 51, 1)",
                                                                textTransform: "none",
                                                                fontSize: "16px",
                                                                height: "42px",
                                                                borderRadius: "13px",
                                                                // maxWidth: "218px",
                                                                width: "100%",
                                                                "&:hover": {
                                                                    backgroundColor: "#000",
                                                                    color: "#fff",
                                                                },
                                                            }}
                                                            onClick={() => {
                                                                handleSearch2(selectedCar.modification_id);
                                                                handleAdd(selectedCar);
                                                            }}
                                                        >
                                                            Search Parts
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={5.8} sm={5.8} md={5.8} lg={5.8}>
                                                        <Button
                                                            variant="contained"
                                                            fullWidth
                                                            sx={{
                                                                backgroundColor: "rgba(255, 102, 51, 1)",
                                                                textTransform: "none",
                                                                fontSize: "16px",
                                                                height: "42px",
                                                                borderRadius: "13px",
                                                                // maxWidth: "218px",
                                                                width: "100%",
                                                                "&:hover": {
                                                                    backgroundColor: "#000",
                                                                    color: "#fff",
                                                                },
                                                            }}
                                                            onClick={() => {
                                                                navigateToOEMCatalog(selectedCar)
                                                                handleAdd(selectedCar);
                                                            }}
                                                        >
                                                            OEM Catalog
                                                        </Button>
                                                    </Grid>
                                                </>
                                            ) : (
                                                <>
                                                    <Grid item xs={12} sm={12} md={12} lg={12}
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <Button
                                                            variant="contained"
                                                            // fullWidth
                                                            sx={{
                                                                backgroundColor: "rgba(255, 102, 51, 1)",
                                                                textTransform: "none",
                                                                fontSize: "16px",
                                                                height: "42px",
                                                                borderRadius: "13px",
                                                                // maxWidth: "218px",
                                                                width: isMobile ? '100%' : '250px',
                                                                "&:hover": {
                                                                    backgroundColor: "#000",
                                                                    color: "#fff",
                                                                },
                                                            }}
                                                            onClick={() => {
                                                                handleSearch2(selectedCar.modification_id);
                                                                handleAdd(selectedCar);
                                                            }}
                                                        >
                                                            Search Parts
                                                        </Button>
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                    </Grid>

                                ) : (
                                    <Box
                                        display="flex"
                                        flex={1}
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{
                                            height: "300px",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily: "Bebas Neue",
                                                fontWeight: 600,
                                                fontSize: "22px",
                                                textAlign: "center",
                                            }}
                                        >
                                            Please Check Your Number Plate Again!
                                        </Typography>
                                    </Box>
                                )}
                            </>
                        )}
                    </Box>

                </DialogContent>

            </Dialog >
        </>
    )
}

export default NumberPlateDialog;
